import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IWizardStepRendererProps, useWizardStep } from '@agilepoint/wat-react-ux';
import { useTranslate } from '@agilepoint/wat-react';
import { StylingForm } from 'modules/shared/forms';
import { IStylingFormFields } from 'modules/shared/types';
import { IMobileApplicationDetails } from 'modules/create-new-app/queries';
import { WizardNavigationActions } from '../footers';
import { MobileAppHelpLink } from 'common';

interface IStylingProps extends IWizardStepRendererProps {
    defaultValues?: IStylingFormFields;
    onSaveStylingDetails: (formData: IStylingFormFields) => Promise<{
        UpdateMobileAppResult: IMobileApplicationDetails;
    }>
}

export const Styling = React.memo((props: IStylingProps) => {
    const { stepId, defaultValues, onSaveStylingDetails } = props;
    const { saveData, data } = useWizardStep(stepId);
    const translate = useTranslate();
    const subHeading = translate('modules.createNewApp.steps.styling.stylingSubtitle');

    const form = useForm<IStylingFormFields>({
        mode: 'onChange',
        defaultValues
    });

    const { trigger, getValues, reset } = form;

    const onNext = React.useCallback(async () => {
        if (!await trigger()) {
            return false;
        }
        const formData = getValues();
        return onSaveStylingDetails(formData).then((result) => {
            saveData({ updateMobileAppRsponse: result.UpdateMobileAppResult, formData });
            return true;
        }).catch(() => false);
    }, [trigger, getValues, onSaveStylingDetails, saveData]);

    React.useEffect(() => {
        data && reset(data.formData);
    }, [reset, data]);

    return (
        <FormProvider {...form}>
            <MobileAppHelpLink id="styling" />
            <StylingForm containerHeight='calc(100% - 50px)' subHeading={subHeading} />
            <WizardNavigationActions
                stepId={stepId}
                hook={onNext} />
        </FormProvider>
    );
});
